/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import { currencies } from '../../utilities/constants';
import { formatNumber } from '../../utilities/formatHelpers';
import { dynamicAssets } from '../../utilities/helpers';

const LoyaltyProgramNewUi = ({
  label,
  subLabel,
  onClick,
  disabled,
  className,
  image,
  rightImage,
  cashbackData,
  onInfoIconMouseEnter,
  onInfoIconMouseLeave,
  cashbackDisplayAmount,
  onClickRightImage,
}) => {
  const { t: translate } = useTranslation();
  const currency = currencies[cashbackData?.cashback_currency?.toUpperCase()];
  const availableCashbackRaward = formatNumber(
    cashbackData?.total_reward_amount * currency.conversion,
    currency?.decimal
  );

  const handleClickOnQuestionMark = (e) => {
    e.stopPropagation();
    onClickRightImage();
  };

  return (
    <div
      onClick={onClick}
      className={`position-relative loyalty-banner p-4 my-3 cursor-pointer hover-container position-relative ${
        disabled ? 'disabled-block' : ''
      }
      ${isMobile && 'mb-2'}
      ${className}`}
      tabIndex={-1}
      role="presentation">
      <img
        className="payment-banner-image rounded-extra payment-banner-image-custom"
        src={dynamicAssets('./assets/images/loyalty-bg.png')}
        width="100%"
        height="100%"
        alt="plus"
      />
      <div>
        <div className="d-flex position-relative flex-row align-items-center">
          <div
            className="bg-night p-2 d-flex me-2 justify-content-center"
            style={{ borderRadius: '124px' }}>
            <img
              alt={image}
              src={dynamicAssets(`./assets/images/${image}.svg`)}
              style={{ width: '1.3rem', height: '1.3rem' }}
            />
          </div>

          <div role="presentation" className="ms-1 pe-3">
            <p>
              <b>{label || translate('manage_your_accounts_label')}</b>
            </p>
          </div>

          {!rightImage && (
            <i
              style={{ width: '1rem' }}
              className="icon icon-arrow-next-navigation text-primary text-f4 cursor-pointer"
              role="button"
              aria-label={label || translate('manage_your_accounts_label')}
              tabIndex={0}
              onKeyDown={() => {}}
            />
          )}

          {rightImage &&
            (isMobile ? (
              <div
                role="button"
                tabIndex={0}
                className="p-2"
                onClick={handleClickOnQuestionMark}
                onKeyDown={handleClickOnQuestionMark}>
                <i
                  style={{ width: '1rem', zIndex: 10000 }}
                  className={`icon ${rightImage} text-shadow text-f4 cursor-pointer d-block text-hover-dimmed`}
                  aria-label="info"
                />
              </div>
            ) : (
              <i
                style={{ width: '1rem', zIndex: 10000 }}
                role="button"
                tabIndex={0}
                className={`icon ${rightImage} text-shadow text-f4 cursor-pointer d-block text-hover-dimmed`}
                aria-label="info"
                onMouseEnter={cashbackData ? onInfoIconMouseEnter : null}
                onMouseLeave={cashbackData ? onInfoIconMouseLeave : null}
              />
            ))}
        </div>
        <div className="pt-3">
          {cashbackData && (
            <p>
              <Trans
                i18nKey="loyalty_program_available_cashback_currency_sublabel"
                values={{
                  amount: availableCashbackRaward,
                  currency: cashbackData.cashback_currency,
                }}
                components={[<span key="amount" className="text-white" />]}
              />
            </p>
          )}
          <p className="text-f6 text-shadow"> {cashbackDisplayAmount}</p>
          {!cashbackData && subLabel && <p className="text-shadow ">{subLabel}</p>}
        </div>
      </div>
    </div>
  );
};

export default LoyaltyProgramNewUi;

LoyaltyProgramNewUi.propTypes = {
  onClick: PropTypes.func.isRequired,
  image: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  subLabel: PropTypes.string,
  label: PropTypes.string,
  cashbackDisplayAmount: PropTypes.string,
  className: PropTypes.string,
  rightImage: PropTypes.string,
  cashbackData: PropTypes.object,
  onInfoIconMouseEnter: PropTypes.func,
  onInfoIconMouseLeave: PropTypes.func,
  onClickRightImage: PropTypes.func,
};

LoyaltyProgramNewUi.defaultProps = {
  subLabel: null,
  label: null,
  cashbackDisplayAmount: null,
  disabled: null,
  className: null,
  rightImage: null,
  cashbackData: null,
  onInfoIconMouseEnter: null,
  onInfoIconMouseLeave: null,
  onClickRightImage: null,
};
